import { Component, Vue } from 'vue-property-decorator';

import ApiService from '@/services/api.service';
import { Errors } from '@/definitions';

import template from './login.vue';
import { Action } from '@/store';

enum LoginErrors {
  EMAIL_MISSING    = 'EMAIL_MISSING',
  EMAIL_INVALID    = 'EMAIL_INVALID',
  PASSWORD_MISSING = 'PASSWORD_MISSING',
  PASSWORD_INVALID = 'PASSWORD_INVALID',
  GENERAL_UNKNOWN  = 'GENERAL_UNKNOWN',
  GENERAL_FAILURE  = 'GENERAL_FAILURE',
};

@Component({
  mixins: [template],
})
export default class Login extends Vue {
  title: string = this.$package.title;
  userEmail: string = '';
  userPassword: string = '';
  stayLoggedIn: boolean = false;
  emailError: string | null = null;
  passwordError: string | null = null;
  generalError: string | null = null;

  created() {
    document.addEventListener('keypress', this.onEnterPress);
    const stayLoggedIn = localStorage.getItem('STAY_LOGGED_IN');
    this.stayLoggedIn = stayLoggedIn === 'true';
  }

  beforeDestroy() {
    document.removeEventListener('keypress', this.onEnterPress);
  }

  onEnterPress(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.code === 'Enter' || event.charCode === 13) {
      this.sendForm();
    }
  }

  resetForm() {
    this.userEmail = '';
    this.userPassword = '';
  }

  error(key: LoginErrors): string {
    return this.$t(`errors.login.${key}`) as string;
  }

  forgotPassword() {
    this.$router.push({ path: 'forgot-password' });
  }

  async sendForm() {
    this.emailError = null;
    this.passwordError = null;
    this.generalError = null;

    localStorage.setItem('STAY_LOGGED_IN', `${this.stayLoggedIn}`);

    // Check email field
    if (this.userEmail.length === 0) {
      this.emailError = this.error(LoginErrors.EMAIL_MISSING);
    } else if (!/.+@.+\.[a-zA-Z]+/.test(this.userEmail)) {
      this.emailError = this.error(LoginErrors.EMAIL_INVALID);
    }

    // Check password field
    if (this.userPassword.length === 0) {
      this.passwordError = this.error(LoginErrors.PASSWORD_MISSING);
    } else if (this.userPassword.length < 5) {
      this.passwordError = this.error(LoginErrors.PASSWORD_INVALID);
    }

    if (!this.emailError && !this.passwordError) {
      try {
        const authSuccess = await ApiService.authenticate({
          user: this.userEmail,
          password: this.userPassword,
          stayLoggedIn: this.stayLoggedIn
        });
        if (authSuccess) {
          this.$router.push({ path: this.$Store.state.user.isAppAdmin ? '/admin' : '/' });
        }
        
      } catch(e) {
        const error = e as Error;
        switch(error.message) {
          case 'Network Error': {
            this.generalError = this.error(LoginErrors.GENERAL_FAILURE);
            break;
          }
          case Errors.CREDENTIALS_INVALID: {
            this.$Store.dispatch(Action.SHOW_ALERT, { text: `errors.login.${LoginErrors.GENERAL_FAILURE}`, type: 'danger' });
            this.resetForm();
            break;
          }
          default: {
            this.$Store.dispatch(Action.SHOW_ALERT, { text: `errors.login.${LoginErrors.GENERAL_UNKNOWN}`, type: 'danger' });
            break;
          }
        }
      }
    }
  }
}